// Progressive enhancement: the full, crawlable directory is visible without JS.
export function matchesCard(name: string, group: string, query: string, selectedGroup: string): boolean {
  const normalize = (value: string) => value.toLowerCase().replace(/judgment/g, 'judgement').replace(/\s+/g, ' ').trim();
  return (!selectedGroup || group === selectedGroup) && normalize(name).includes(normalize(query));
}

if (typeof document !== 'undefined') {
  const search = document.querySelector<HTMLInputElement>('#card-search');
  const group = document.querySelector<HTMLSelectElement>('#card-group');
  const count = document.querySelector<HTMLElement>('#card-count');
  const empty = document.querySelector<HTMLElement>('#card-empty');
  const controls = document.querySelector<HTMLElement>('[data-library-controls]');
  const links = [...document.querySelectorAll<HTMLAnchorElement>('[data-card-name]')];
  if (search && group && count && empty && controls) {
    const filter = () => {
      let visible = 0;
      for (const link of links) {
        link.hidden = !matchesCard(link.dataset.cardName || '', link.dataset.cardGroup || '', search.value, group.value);
        if (!link.hidden) visible++;
      }
      count.textContent = `${visible} of ${links.length} cards`;
      empty.hidden = visible !== 0;
    };
    controls.hidden = false;
    search.addEventListener('input', filter);
    group.addEventListener('change', filter);
    document.querySelector('#card-reset')?.addEventListener('click', () => {
      search.value = '';
      group.value = '';
      filter();
      search.focus();
    });
  }
}
